import { ICheckbox } from "interfaces/ICheckbox"
import { CheckboxContainer, HiddenCheckbox, StyledCheckbox } from "theme/common/CheckBox"
import { IconBoxCheck } from "theme/common/Icon.styled"

const Checkbox = ({ className, checked, label, ...props }: ICheckbox) => (
  <label>
    <CheckboxContainer className={className}>
      <HiddenCheckbox {...props} />
      <StyledCheckbox checked={checked}>
        <IconBoxCheck />
      </StyledCheckbox>
    </CheckboxContainer>
    {label && <span>{label}</span>}
  </label>
)

export default Checkbox
